import React, { useState, useEffect } from 'react'
import { PlusCircle, RefreshCw } from 'lucide-react'
import { useSystemsContext } from '../hooks/useSystemsContext'
import { useAuthContext } from '../hooks/useAuthContext'
import SystemDetails from '../components/SystemDetail'
import SystemForm from '../components/SystemForm'
import { fetchSystems } from '../helper/environmentHelper'
import SystemSettings from '../components/SystemSettings/SystemSettings'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const Home = () => {
    const [newSystem, setNewSystem] = useState<boolean>(false)
    const [systemPopup, setSystemPopup] = useState<boolean>(false)
    const { systems, dispatch } = useSystemsContext()
    const [selectedSystem, setSelectedSystem] = useState(null) // Renamed for clarity
    const { user, dispatch: dispatchUser } = useAuthContext()

    const handleCreateSystem = () => {
        setNewSystem(true)
        setSystemPopup(true)
    }

    // Remove the first useEffect - it was causing infinite loops
    // Only keep this one:
    useEffect(() => {
        if (user) {
            fetchSystems(user, dispatch, dispatchUser)
        }
    }, [user, dispatch, dispatchUser, systemPopup])

    const refreshPage = () => {
        window.location.reload()
    }

    return (
        <>
            <header
                className={cn(
                    'device-toolbar !grid !h-auto w-full min-w-0 shrink-0 grid-cols-2 items-center gap-x-2 gap-y-3 overflow-visible border-b border-zinc-800/90 bg-zinc-900/95 px-3 py-3.5 shadow-sm backdrop-blur-sm supports-[backdrop-filter]:bg-zinc-900/80 sm:!flex sm:min-h-[4.75rem] sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-3 sm:gap-y-0 sm:px-5 sm:py-4'
                )}
                aria-label="Systems toolbar"
            >
                <span className="col-span-2 flex w-full flex-col items-center justify-center text-center text-xs font-semibold uppercase tracking-wide text-zinc-400 sm:col-auto sm:mr-auto sm:w-auto sm:items-start sm:justify-start sm:text-left sm:text-sm">
                    Systems
                </span>
                <Button
                    type="button"
                    onClick={handleCreateSystem}
                    className="h-10 min-h-10 w-full min-w-0 justify-center gap-2 bg-emerald-600 px-2 text-sm font-semibold text-white shadow hover:bg-emerald-500 sm:w-auto sm:shrink-0 sm:px-4"
                >
                    <PlusCircle className="size-4 shrink-0" aria-hidden />
                    <span className="truncate">Create system</span>
                </Button>
                <Button
                    type="button"
                    variant="outline"
                    onClick={refreshPage}
                    className="h-10 min-h-10 w-full min-w-0 justify-center gap-2 border-zinc-600 bg-zinc-950/60 px-2 text-sm text-zinc-100 shadow-sm hover:bg-zinc-800 hover:text-white sm:w-auto sm:shrink-0 sm:px-4"
                >
                    <RefreshCw className="size-4 shrink-0" aria-hidden />
                    <span className="truncate">Refresh</span>
                </Button>
            </header>

        {/* Simplified conditions */}
        {systems && systems.length === 0 && (
            <div className="mx-auto flex min-h-[50vh] w-full max-w-6xl flex-col items-center justify-center px-4 py-12 text-zinc-300">
                <h3 className="text-lg font-medium">No systems found</h3>
            </div>
        )}
    {! [null, undefined].includes(selectedSystem) && JSON.stringify(selectedSystem) !== '{}' ? (
        <div className="mx-auto w-full max-w-6xl">
        <SystemSettings 
            system={selectedSystem} 
            setSystem={setSelectedSystem} 
            setSystemPopup={setSystemPopup} 
            systemPopup={systemPopup} 
            setNewSystem={setNewSystem}  
            newSystem={newSystem}
        />
        </div>

    ): (

  systems && systems.length > 0 && (
            <div className="mx-auto flex w-full max-w-6xl flex-col flex-wrap gap-4 px-2 py-2 sm:flex-row sm:items-stretch sm:justify-center sm:px-4">
               {systems.map((system) => (
                <SystemDetails 
                    system={system} 
                    key={system._id} 
                    setSystemPopup={setSystemPopup} 
                    setSystem={setSelectedSystem} // Use the renamed variable
                    setNewSystem={setNewSystem}
                />
               ))}
            </div>
        )        
    )}

      
    { newSystem && (
        <SystemForm 
            system={selectedSystem} 
            setSystem={setSelectedSystem} 
            setSystemPopup={setSystemPopup} 
            systemPopup={systemPopup} 
            setNewSystem={setNewSystem}  
            newSystem={newSystem}
        />
    )}   
        </> 
     );
}
 
export default Home;